//basic
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, exhaustMap, map, of, tap } from 'rxjs';

//it's not a pattern
import { RevenueService } from 'src/app/shared/services/revenue.service';
import {
  activateRevenue,
  inactivateRevenue,
  loadRevenue,
  loadRevenueSuccess,
  saveRevenue,
} from './revenue.actions';
import { NotifyService } from 'src/app/shared/services/notify.service';

@Injectable()
export class RevenueEffects {
  constructor(private service: RevenueService, private action$: Actions,private notify: NotifyService) {}

  loadRevenue$ = createEffect(() =>
    this.action$.pipe(
      ofType(loadRevenue),
      exhaustMap(() =>
        this.service
          .getAll()
          .pipe(
            map((res) => loadRevenueSuccess({ lista: res })),
            catchError((error) => {
              this.notify.emitError('Falha ao carregar registros')
              return of(error.error['hydra:description'])
          })
          )
      )
    )
  );

  saveRevenue$ = createEffect(() =>
    this.action$.pipe(
      ofType(saveRevenue),
      concatMap(({ revenue }) =>
        this.service.save(revenue).pipe(
          tap(() => this.notify.saveSuccess()),
          map((res) => loadRevenue()),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description'])
            return of(error.error['hydra:description']);
          })
        )
      )
    )
  );

  inactivateRevenue$ = createEffect(() =>
    this.action$.pipe(
      ofType(inactivateRevenue),
      concatMap(({ id }) =>
        this.service.inactivate(id).pipe(
          tap(() => this.notify.emitSuccess('Receita desativada com sucesso!')),
          map((res) => loadRevenue()),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description'])
            return of(error.error['hydra:description']);
          })
        )
      )
    )
  );

  activateRevenue$ = createEffect(() =>
    this.action$.pipe(
      ofType(activateRevenue),
      concatMap(({ id }) =>
        this.service.activate(id).pipe(
          tap(() => this.notify.emitSuccess('Receita ativada com sucesso!')),
          map((res) => loadRevenue()),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description'])
            return of(error.error['hydra:description']);
          })
        )
      )
    )
  );
}
